import { SelectContentEvent, trackGAEvent } from '@moonpig/web-core-analytics'
import {
  AccordionSection,
  AccordionSectionAction,
  AccordionSectionNameLookup,
} from '../../types'

export const createTrackAccordionSectionClick = ({
  currentSections,
  updatedSections,
  productId,
}: {
  currentSections: AccordionSection[]
  updatedSections: AccordionSection[]
  productId: string
}) => {
  if (updatedSections.length > currentSections.length) {
    const openSection = updatedSections.filter(
      section => !currentSections.includes(section),
    )[0]

    trackGAEvent(
      sectionClickEvent({
        productId,
        section: openSection,
        action: AccordionSectionAction.OPEN,
      }),
    )
  } else {
    const closedSection = currentSections.filter(
      section => !updatedSections.includes(section),
    )[0]

    trackGAEvent(
      sectionClickEvent({
        productId,
        section: closedSection,
        action: AccordionSectionAction.CLOSE,
      }),
    )
  }
}

const sectionClickEvent = ({
  productId,
  section,
  action,
}: {
  productId: string
  section: AccordionSection
  action: AccordionSectionAction
}): SelectContentEvent => {
  const sectionName = AccordionSectionNameLookup[section]
  const label =
    `product details | ${productId} | accordion | ${sectionName} | ${action}`.toLowerCase()
  return {
    event: 'select_content',
    content_data: {
      content_type: label,
    },
    event_data: {
      category: 'product details',
      action: 'view item',
      label,
      non_interaction: true,
      value: undefined,
    },
    error_data: undefined,
    ecommerce: undefined,
  }
}
